import Authenticate from "../components/pages/_authenticate";
import Ajuda from "./_ajuda";
import Colunas from "./_colunas";
import Doutrinas from "./_doutrinas";
import Home from "./_home";
import Perfil from "./_perfil";
import Pesquisa from "./_pesquisa";
import Privacidade from "./_privacidade";
import Produtos from "./_produtos";
import DoctrineDetails from "./_resultsDetails/_doctrineDetails";
import LegislationDetails from "./_resultsDetails/_legislationDetails";

import ModelDetails from "./_resultsDetails/_modelDetails";
import SearchResults from "./_searchResults";
import Sobre from "./_sobre";

const pages = [
  {
    Element: Authenticate,
    path: "/autenticar/:token",
    headerClass: "authenticate",
    id: "authenticate",
    isModule: false,
    name: "Autenticte",
    order: null,
    protectedPage: false,
    showFooter: false,
    showHeader: false,
  },
  {
    Element: Home,
    headerClass: "home",
    id: "home",
    isModule: false,
    name: "Home",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Perfil,
    id: "perfil",
    isModule: false,
    name: "Perfil",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Pesquisa,
    id: "pesquisa",
    isModule: false,
    name: "Pesquisa",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: SearchResults,
    id: "resultados",
    isModule: false,
    name: "Resultados",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Sobre,
    id: "sobre",
    isModule: false,
    name: "Sobre",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Produtos,
    id: "produtos",
    isModule: false,
    name: "Produtos",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Colunas,
    id: "colunas",
    isModule: false,
    name: "Colunas",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: DoctrineDetails,
    id: "doutrina",
    path: "/doutrinas/:id",
    isModule: false,
    name: "Doutrina",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Doutrinas,
    id: "doutrinas",
    isModule: false,
    name: "Doutrinas",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: ModelDetails,
    id: "modelsDetail",
    path: "/modelos/:id",
    isModule: false,
    name: "Modelo",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: LegislationDetails,
    id: "legislação",
    path: "/legislacao/:id",
    isModule: false,
    name: "Legislação",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Ajuda,
    id: "ajuda",
    isModule: false,
    name: "Ajuda",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
  {
    Element: Privacidade,
    id: "privacidade",
    isModule: false,
    name: "Privacidade",
    order: null,
    protectedPage: true,
    showFooter: true,
    showHeader: true,
  },
];

export default pages;
